// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer{position:fixed;bottom:0;width:100%;padding:0 0 30px}.footer__content-left{font-family:\"Roboto Mono\",monospace;font-size:13px}.footer__socialmedia-item{display:inline-block;margin-right:20px}\n", ""]);
// Exports
module.exports = exports;
